// 전설 고유 효과 → 연출 큐 종류(c017). Ev.GearUnique a(LEGEND_UNIQUES 번호)를 렌더(VFX)·UI(스킬 바)가 같은 표로 읽는다.
// 효과 번호는 content/items LEGEND_UNIQUES 순서이고, 큐 종류는 그 효과의 fx 칸 이름으로 정한다(목록 순서가 바뀌어도 연출이 따라간다).
import { LEGEND_UNIQUES } from './content/items';

/** 연출 큐 종류 */
export const GearCue = {
  None: 0,
  /** 회피의 방패: 영웅 몸에 짧은 강철 거품 + 발밑 고리 */
  Shield: 1,
  /** 피의 수확: 처치 자리에서 영웅 가슴으로 오르는 녹색 알갱이 */
  Heal: 2,
  /** 샘솟는 마력: 같은 길의 청색 알갱이 */
  Mp: 3,
  /** 투지: 같은 길의 잿불 알갱이(각성 게이지) */
  Awaken: 4,
  /** 칼날의 박자: 스킬 바 쿨타임 칸에 시계 바늘 반짝임(UI) */
  Refund: 5,
  /** 벼랑 끝 칼날: 화면 가장자리 옅은 붉은 맥동(섬광 예산 안) */
  LowHp: 6,
} as const;
export type GearCueId = (typeof GearCue)[keyof typeof GearCue];

const BY_KEY: Readonly<Record<string, GearCueId>> = {
  dodgeShield: GearCue.Shield, killHeal: GearCue.Heal, killMp: GearCue.Mp, killAwaken: GearCue.Awaken, critRefund: GearCue.Refund, lowHpDmg: GearCue.LowHp,
};

/** LEGEND_UNIQUES 번호 → 큐 종류(엘리트 피해처럼 연출이 없는 효과는 None) */
export const UNIQUE_CUES: readonly GearCueId[] = LEGEND_UNIQUES.map((u) => {
  for (const k of Object.keys(u.fx)) { const c = BY_KEY[k]; if (c !== undefined) return c; }
  return GearCue.None;
});

/** Ev.GearUnique a → 큐 종류(범위 밖이면 None) */
export function uniqueCueOf(a: number): GearCueId {
  return a >= 0 && a < UNIQUE_CUES.length ? UNIQUE_CUES[a | 0] : GearCue.None;
}
